import * as React from "react";

function SvgStateNormal(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path className="state-normal_svg__st0" d="M7 14.8c-.3 0-.6-.2-.7-.5l-5-12c-.1-.3 0-.6.2-.8.2-.2.5-.3.8-.2l12 5c.3.1.5.4.5.7 0 .3-.2.6-.5.7L9.4 9.4l-1.7 4.9c-.1.2-.4.4-.7.5zM3.4 3.4l3.5 8.5L8 8.6c.1-.2.2-.4.5-.5L11.8 7 3.4 3.4z" /></svg>;
}

export default SvgStateNormal;